// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectClosePositionMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"

export let ClosePositionMessageProcessor = function (parentDecoder)
{
    MessageProcessorBase.call(this)
    this.decoder = parentDecoder
}

ClosePositionMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

ClosePositionMessageProcessor.prototype.decode = function (fieldSet)
{
    let factory = FieldsFactory

    let message = new DirectClosePositionMessage()
    // Open Order ID
    message.Id = fieldSet.GetValue(factory.FIELD_POSITION_ID).toString()
    // Close price
    message.ClosePrice = fieldSet.GetValue(factory.FIELD_PRICE)
    // Close time
    message.CloseTime = fieldSet.GetValue(factory.FIELD_DATE)
    message.OrderWasManual = fieldSet.GetValue(factory.FIELD_ORDER_IS_WAS_MANUAL)

    return [message]
}